import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal, Select, DatePicker } from 'components';
import { TrashIcon, EditIcon, CleanIcon, AddWhiteIcon, TrashWhiteIcon, ConfirmIcon, StarIcon, CopyIcon, Menu as MenuIcons } from 'assets/icons';
import { Globals, checkPermission, Constants } from 'utils';
import { PointService } from 'services';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Points extends React.Component<Props> {

	state = {
		quantity_discounts: 0,
		quantity_use: 0,
		quantity_referrals: 0,
		quantity_purchases: 0
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Mis Conectados',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await PointService.client.get({
			withoutLoading,
			user_id: this.props.user?.id
		});
		this.setState({
			quantity_discounts: res.quantity_discounts || 0,
			quantity_use: res.quantity_use || 0,
			quantity_referrals: res.quantity_referrals || 0,
			quantity_purchases: res.quantity_purchases || 0
		});
	}

	render() {
		return (
			<div id="my-points">
				<p className="title">Tus conectados contratan y tú ganas</p>

				<div className="container-referrals row">
					<div className="col-md-3">
						<div className="item">
							<p className="label">Número de conectados registrados:</p>
							<p className="value">{ this.state.quantity_referrals }</p>
						</div>
					</div>
					<div className="col-md-3">
						<div className="item">
							<p className="label">Número de conectados que contrataron el servicio:</p>
							<p className="value">{ this.state.quantity_purchases }</p>
						</div>
					</div>
					<div className="col-md-3">
						<div className="item">
							<p className="label">Número de servicios obtenidos:</p>
							<p className="value">{ this.state.quantity_discounts }</p>
						</div>
					</div>
					<div className="col-md-3">
						<div className="item">
							<p className="label">Número de servicios obtenidos a la fecha:</p>
							<p className="value">{ this.state.quantity_use }</p>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Points);